class Player {
    constructor(script) {
        this.audioContext = new AudioContext();
        this.voice = window.speechSynthesis.getVoices().find((voice) => voice.name === 'Karen')
        this.script = script
        this.soundCache = new SoundCache(this.audioContext)
    }

    async play(config, sonification) {
        const sonificationData = await fetch(sonification)
        const json = await sonificationData.json()
        await new Sonification(config, this.audioContext, this.voice, this.script, this.soundCache, json).play()
    }
}

function defaultise(val, defa) {
    if (typeof val === 'undefined') {
        val = val || defa
    }
    return val
}

class Sonification {
    constructor(config, audioContext, voice, script, soundCache, sonification) {
        this.audioContext = audioContext;
        this.voice = voice
        this.script = script
        this.sonification = sonification
        this.config = config
        this.soundCache = soundCache
    }

    async play() {
        await this._playIntro()
        await this._playSonification();
    }


    async _playIntro() {
        if (this.config.playIntro) {
            for (const part of this.script.intro) {
                await this._speak(part.text);
                await Promise.all([this._playSound(part.sound,
                                                          defaultise(part.volume, 1),
                                                          defaultise(part.balance, 0),
                                                          defaultise(part.lowPass, 20000))])
                await this._pause(part.pauseAfter || 0);
            }
            console.log("Played intro")
        }
    }

    async _playSonification() {
        for (const hour of this.sonification.hours) {
            const spoken = []
            const startTime = this.audioContext.currentTime
            const hourSounds = hour.sounds.map((sound) => this._playSound(sound.sound,
                                                                defaultise(sound.volume, 1),
                                                                defaultise(sound.balance, 0),
                                                                defaultise(sound.lowPass, 20000),
                                                                startTime))
            if (hour.speak) {
                spoken.push(this._speak(hour.speak));
            }
            await Promise.all(spoken.concat(hourSounds))
            console.log("Played " + hour.speak)
        }
        console.log("Played sonification")

    }

    async _pause(time) {
        return new Promise(resolve => {
            setTimeout(resolve, 1000 * time);
        });
    }


    async _playSound(sound, vol, bal, cutoff, startTime) {
        if (!sound) {
            return Promise.resolve();
        }

        const audioContext = this.audioContext;
        const snd = await this.soundCache.getSound(sound)
        const soundBuffer = snd.buffer()
        const start = defaultise(startTime, audioContext.currentTime)

        const sampleSource = audioContext.createBufferSource();
        sampleSource.buffer = soundBuffer;

        const gainNode = audioContext.createGain();
        gainNode.connect(audioContext.destination)

        const log2vol = Math.log(vol) / Math.log(2)
        gainNode.gain.value = Math.pow(10, log2vol)

        const panner = audioContext.createStereoPanner()
        panner.connect(gainNode)

        panner.pan.value = bal


        const biquadFilter = audioContext.createBiquadFilter();
        biquadFilter.type = "lowpass"
        biquadFilter.frequency.value = cutoff

        biquadFilter.connect(panner)

        sampleSource.connect(biquadFilter)

        sampleSource.loop = true;

        return new Promise(resolve => {
            console.log(start)
            sampleSource.start(start);
            sampleSource.stop(start + (1.5 / this.config.sonificationSpeed));

            sampleSource.onended = resolve
        });
    }

    async _speak(text) {

        return new Promise(resolve => {
            const msg = new SpeechSynthesisUtterance();
            msg.text = text
            msg.voice = this.voice
            msg.rate = this.config.narrationSpeed

            msg.onend = resolve
            window.speechSynthesis.speak(msg)
        });
    }

}

class Sound {
    constructor(audioBuffer) {
        this.audioBuffer = audioBuffer
    }

    buffer() {
        return this.audioBuffer;
    }
}

class SoundCache {
    constructor(audioContext) {
        this.cache = {}
        this.audioContext = audioContext
    }

    async getSound(filepath) {
        if (!this.cache[filepath]) {
            const response = await fetch("./" + filepath);
            const arrayBuffer = await response.arrayBuffer();
            const audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer);
            this.cache[filepath] = new Sound(audioBuffer)
        }
        return this.cache[filepath];
    }
}

export default Player;